import { Operators, OperatorsDef, } from "@/components/fields/base/BaseSearchField";
/** Opérateur de recherche pour le champ de type base*/
export var operators = [
    // OperatorsDef[Operators.OPERATOR_NULL],
    OperatorsDef[Operators.OPERATOR_EQUAL],
    OperatorsDef[Operators.OPERATOR_STARTS_WITH],
    OperatorsDef[Operators.OPERATOR_CONTAINS],
    OperatorsDef[Operators.OPERATOR_ENDS_WITH],
    OperatorsDef[Operators.OPERATOR_NOT_NULL],
    OperatorsDef[Operators.OPERATOR_IS_NULL],
];
